import { platformSwitch } from '@certilogo/design-system/dist/configuration';

import * as web from './web';
import * as native from './native';

// eslint-disable-next-line import/prefer-default-export
export const { Wrapper } = platformSwitch({
  web,
  native,
});
